// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2rwOo","header":"PatientQuestionnaire_header__H8KOq","info":"PatientQuestionnaire_info__3_vTk"};